const s = {
  name: "WestAfricanCfaFranc",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13,14c-1.7,0-3,1.3-3,3v6c0,1.7,1.3,3,3,3s3-1.3,3-3v-1h-2v1c0,0.5-0.5,1-1,1s-1-0.5-1-1v-6c0-0.5,0.5-1,1-1
			s1,0.5,1,1v1h2v-1C16,15.3,14.7,14,13,14z"/>
		<path class="st0" d="M17,17c0-1.7,1.3-3,3-3s3,1.3,3,3v1h-2v-1c0-0.5-0.5-1-1-1c-0.5,0-1,0.5-1,1v3h2v2h-2v4h-2V17z"/>
		<path class="st0" d="M26,22v4h-2v-9c0-1.7,1.3-3,3-3s3,1.3,3,3v9h-2v-4H26z M26,17v3h2v-3c0-0.5-0.5-1-1-1C26.5,16,26,16.5,26,17z
			"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31.1,0,20,0z M2,20c0-9.9,8.1-18,18-18c9.9,0,18,8.1,18,18
			s-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as WestAfricanCfaFranc
};
